import axios, { AxiosPromise } from "axios";

export const FETCH_CUSTOM_NAVIGATION = "AKASHA_FETCH_CUSTOM_NAVIGATION";
export const FETCH_CUSTOM_NAVIGATION_PENDING = `${FETCH_CUSTOM_NAVIGATION}_PENDING`;
export const FETCH_CUSTOM_NAVIGATION_FULFILLED = `${FETCH_CUSTOM_NAVIGATION}_FULFILLED`;
export const FETCH_CUSTOM_NAVIGATION_REJECTED = `${FETCH_CUSTOM_NAVIGATION}_REJECTED`;

interface AxiosPromiseResponse {
  data: any;
}

interface GetCustomNavigationAction {
  type: typeof FETCH_CUSTOM_NAVIGATION;
  payload: AxiosPromise<AxiosPromiseResponse>;
}

export interface GetCustomNavigationActionResponse {
  type:
    | typeof FETCH_CUSTOM_NAVIGATION_FULFILLED
    | typeof FETCH_CUSTOM_NAVIGATION_REJECTED;
  payload: AxiosPromiseResponse;
}

export function getCustomNavigation(
  templateName: string,
  additionalHeaders?: any
): GetCustomNavigationAction {
  let templateContentUrl = `${process.env.REACT_APP_CMS_TEMPLATE_CONTENT_SERVICE_ENDPOINT}/${templateName}`;

  return {
    type: FETCH_CUSTOM_NAVIGATION,
    payload: axios.get(templateContentUrl, {
      headers: {
        ...additionalHeaders,
        "Customer-Facing-Tool": process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem("sessionId"),
      },
    })
  };
}
